import { useFlags } from 'launchdarkly-react-client-sdk';
import { FLAGS } from 'legacy/common/constants/launchdarkly';
import { useGetOffers } from 'legacy/events/hooks';
import { OffersStep } from 'legacy/events/offers.types';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SettingsOption, { OptionType } from '../SettingsOption';

interface OffersSettingsProps {
  navigateToOffers: () => void;
  eventId: string;
  setOffersStep: (step: OffersStep) => void;
}

const OffersSettings: React.FC<OffersSettingsProps> = ({
  navigateToOffers,
  eventId,
  setOffersStep
}) => {
  const { t } = useTranslation(['events']);
  const flags = useFlags();
  const { data } = useGetOffers(eventId, { enabled: !!eventId });

  useEffect(() => {
    if (data?.offers?.length) {
      setOffersStep(OffersStep.OFFERS_LIST);
    } else {
      setOffersStep(OffersStep.CREATE_OFFER);
    }
  }, [data]);

  if (flags[FLAGS.ENABLE_PROMOTER_OFFERS]) {
    return (
      <SettingsOption
        icon={<img src="/img/events/create/offer.svg" height={16} width={16} />}
        title={t('events:settings.promoterOffers.title')}
        actionLabel={t('events:settings.promoterOffers.actionLabel')}
        onClick={navigateToOffers}
        tooltipMessage={t('events:settings.promoterOffers.tooltip')}
        value={
          data?.offers?.length
            ? t('events:settings.promoterOffers.totalCount', {
                count: data?.offers?.length
              })
            : ''
        }
        type={OptionType.Button}
      />
    );
  }
  return null;
};

export default OffersSettings;
